define.alias("shared/components/shared/post/copy/modal", "preview-grid/components/shared/post/copy/modal/index");